import { render, staticRenderFns } from "./EditorIcon.vue?vue&type=template&id=dd15f56c&scoped=true&"
import script from "./EditorIcon.vue?vue&type=script&lang=js&"
export * from "./EditorIcon.vue?vue&type=script&lang=js&"
import style0 from "./EditorIcon.vue?vue&type=style&index=0&id=dd15f56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd15f56c",
  null
  
)

export default component.exports